/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebAuthnResidentKey } from './WebAuthnResidentKey';
import {
    WebAuthnResidentKeyFromJSON,
    WebAuthnResidentKeyFromJSONTyped,
    WebAuthnResidentKeyToJSON,
    WebAuthnResidentKeyToJSONTyped,
} from './WebAuthnResidentKey';
import type { WebAuthnAuthenticatorAttachment } from './WebAuthnAuthenticatorAttachment';
import {
    WebAuthnAuthenticatorAttachmentFromJSON,
    WebAuthnAuthenticatorAttachmentFromJSONTyped,
    WebAuthnAuthenticatorAttachmentToJSON,
    WebAuthnAuthenticatorAttachmentToJSONTyped,
} from './WebAuthnAuthenticatorAttachment';
import type { WebAuthnAttestation } from './WebAuthnAttestation';
import {
    WebAuthnAttestationFromJSON,
    WebAuthnAttestationFromJSONTyped,
    WebAuthnAttestationToJSON,
    WebAuthnAttestationToJSONTyped,
} from './WebAuthnAttestation';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { WebAuthnUserVerification } from './WebAuthnUserVerification';
import {
    WebAuthnUserVerificationFromJSON,
    WebAuthnUserVerificationFromJSONTyped,
    WebAuthnUserVerificationToJSON,
    WebAuthnUserVerificationToJSONTyped,
} from './WebAuthnUserVerification';

/**
 * 
 * @export
 * @interface WebAuthnMethodOptions
 */
export interface WebAuthnMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof WebAuthnMethodOptions
     */
    method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof WebAuthnMethodOptions
     */
    scope?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WebAuthnMethodOptions
     */
    available_credential_ids?: Array<string>;
    /**
     * 
     * @type {WebAuthnAuthenticatorAttachment}
     * @memberof WebAuthnMethodOptions
     */
    attachment?: WebAuthnAuthenticatorAttachment;
    /**
     * 
     * @type {WebAuthnUserVerification}
     * @memberof WebAuthnMethodOptions
     */
    user_verification?: WebAuthnUserVerification;
    /**
     * 
     * @type {WebAuthnResidentKey}
     * @memberof WebAuthnMethodOptions
     */
    resident_key?: WebAuthnResidentKey;
    /**
     * 
     * @type {WebAuthnAttestation}
     * @memberof WebAuthnMethodOptions
     */
    attestation?: WebAuthnAttestation;
}



/**
 * Check if a given object implements the WebAuthnMethodOptions interface.
 */
export function instanceOfWebAuthnMethodOptions(value: object): value is WebAuthnMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function WebAuthnMethodOptionsFromJSON(json: any): WebAuthnMethodOptions {
    return WebAuthnMethodOptionsFromJSONTyped(json, false);
}

export function WebAuthnMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
        'scope': json['scope'] == null ? undefined : json['scope'],
        'available_credential_ids': json['available_credential_ids'] == null ? undefined : json['available_credential_ids'],
        'attachment': json['attachment'] == null ? undefined : WebAuthnAuthenticatorAttachmentFromJSON(json['attachment']),
        'user_verification': json['user_verification'] == null ? undefined : WebAuthnUserVerificationFromJSON(json['user_verification']),
        'resident_key': json['resident_key'] == null ? undefined : WebAuthnResidentKeyFromJSON(json['resident_key']),
        'attestation': json['attestation'] == null ? undefined : WebAuthnAttestationFromJSON(json['attestation']),
    };
}

export function WebAuthnMethodOptionsToJSON(json: any): WebAuthnMethodOptions {
    return WebAuthnMethodOptionsToJSONTyped(json, false);
}

export function WebAuthnMethodOptionsToJSONTyped(value?: WebAuthnMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
        'scope': value['scope'],
        'available_credential_ids': value['available_credential_ids'],
        'attachment': WebAuthnAuthenticatorAttachmentToJSON(value['attachment']),
        'user_verification': WebAuthnUserVerificationToJSON(value['user_verification']),
        'resident_key': WebAuthnResidentKeyToJSON(value['resident_key']),
        'attestation': WebAuthnAttestationToJSON(value['attestation']),
    };
}

